import { IQuantityPerUnit, PackagingUnitType } from '@alberta/konexi-shared';
import { v4 } from 'uuid';

export class QuantityPerUnit implements IQuantityPerUnit {
  _id: string;
  pcn: string;
  quantity: number;
  unit: PackagingUnitType;
  archived: boolean;
  constructor() {
    this._id = v4();
  }
}
